<script>

import { mapGetters } from "vuex";
import { isNotEmpty} from "@/tools/utils";
export default {
  name: "page-sticky",

  data() {
    return {
      currentPath: "main",
    };
  },
  computed: {
    ...mapGetters("page", ["getStickyTabs"]),
  },
  created() {
    this.currentPath = this.$route.path;
  },
  methods: {
    routeTo(tab) {
      let params = {
        name: tab.name
      }
      if(isNotEmpty(tab.params)){
        params.params = tab.params;
      }
      this.$router.push(params);
    },
    removeTab(index) {
      let obj = this.getStickyTabs[index];
      //判断是否关闭的是当前页面
      if (obj.path == this.currentPath) {
        //判断是否是最后一个tab
        if (this.getStickyTabs[index + 1]) {
          this.routeTo(this.getStickyTabs[index + 1]);
        } else {
          this.routeTo(this.getStickyTabs[index - 1]);
        }
      }
      this.$store.dispatch("page/delete_sticky_tab", obj);
    },
  },
  watch: {
    $route: {
      handler(v) {
        if (v.path != "/") {
          this.$store.dispatch("page/add_sticky_tab", v);
        }
        this.currentPath = v.path;
      },
      deep: true,
    },
  },
};
</script>
<template>
  <div class="emis-bar">
    <q-btn dense aria-label="主菜单" class="emis-bar-l" icon="fas fa-bars" size="8px"
           @click="$store.commit('page/change-left-menu-status')"></q-btn>
    <q-page-sticky expand position="top"  class="bar-vue emis-bar-r">
      <q-tabs dense shrink inline-label class="text-grey-7" active-bg-color="primary" active-color="white"
              indicator-color="transparent" v-model="currentPath">
        <q-tab v-for="(tab, index) in getStickyTabs" :key="index" :icon="tab.icon" :ripple="false" :label="tab.title"
               :name="tab.path" exact
               :class="{ 'bg-grey-3': tab.path != currentPath, 'q-mr-sm': true, 'sticky-tab': true }"
               @click="routeTo(tab)">
          <q-icon class="q-ml-xs" v-if="getStickyTabs.length > 1"  name="fas fa-times" @click.stop="removeTab(index)">
            <q-tooltip anchor="top middle" self="bottom middle">关闭</q-tooltip>
          </q-icon>
        </q-tab>
      </q-tabs>
      <!-- </q-toolbar> -->
    </q-page-sticky>
  </div>
</template>
<style lang="scss" scoped>
.emis-bar{
  position: relative;
  margin-left: 7px;
  .emis-bar-l{
    z-index: 3;
    font-size: 8px;
    position: absolute;
    top: -30px;
    left: 0px;
  }
  .emis-bar-r{

  }
}
.bar-vue {
  display: flex;
  justify-content: flex-start;
  // padding-left: 16px;
  background: #fafafa;
  padding: 6px 0 6px 28px;
  align-items: center;
  z-index: 2;
  .sticky-tab {
    min-height: 27px;
    border-radius: 4px;
  }
  .btn-vue {
    margin: 0 16px;
    width: 100%;
  }
}


//tab的label
::v-deep .q-tab__label {
  font-size: 12px;
  height: 12px;
  line-height: 12px;
}

//tab的icon
::v-deep .q-icon{
  font-size: 12px;
  width: 12px;
  height: 12px;
}
//page-bar左右滑动箭头居中
::v-deep .q-tabs--horizontal .q-tabs__arrow--left{
  top:6px
}
::v-deep .q-tabs--horizontal .q-tabs__arrow--right{
  top:6px
}

</style>
